import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// directives
import { AutoFocusDirective } from './auto-focus.directive';
import { NumericOnlyDirective } from './numeric-only.directive';


@NgModule({
  declarations: [
    NumericOnlyDirective,
    AutoFocusDirective,
  ],
  imports: [
    CommonModule
  ],
  exports: [
    NumericOnlyDirective,
    AutoFocusDirective,
  ]
})
export class DirectivesModule { }
